import React, {useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { getAppRolesList, getAppRolesLoading, getControllersList, getControllerRolePermissionsList, getTenantRoles, getControllersTenantPermission } from '../selector/selectors';
import ControllersRoleMapping from '../components/ControllersRoleMapping';
import LoaderComponent from '../components/LoaderComponent';
import { Link } from 'react-router-dom';
import { loadAppRolesList, loadControllersList, loadControllerRolePermissionsList, updateControllerRolePermissions, loadTenantRolesList,loadControllerTenantPermission } from '../api/controllerpermissionsapi';
import ControllerMappingFilter from '../components/ControllerMappingFilter';


const ManageControllerRoleMapping = ({
    isLoading,
    appRolesList,
    startLoadingAppRoles,
    controllerList,
    startLoadingControllers,
    controllerRolePermissionsList,
    startLoadingControllerRolePermissions,
    tenantRolesList
}) => {

    const dispatch                              = useDispatch();
    const [value, setValue]                     = React.useState('1');
    const [tenantValue, setTenantValue]         = React.useState('');
    const [tenantRoles, setTenantRoles]         = React.useState([]);
    const [tenantRoleValue, setTenantRoleValue] = React.useState('');
    const [showController, setShowController]   = React.useState(false);
    const [roleControllerPermissionList, setRoleControllerPermissionList] = React.useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    const changeTenantHandler = (e) => {
        if(e.target.value !== ''){
            setTenantValue(e.target.value);
            setShowController(false);
            setTenantRoleValue('')
            dispatch(loadTenantRolesList(e.target.value));
        } 
    }

    const changeTenantRoleHandler = (e) => {
        if(e.target.value !== ''){
            setShowController(true);
            setTenantRoleValue(e.target.value);
            startLoadingControllerRolePermissions(tenantValue,e.target.value);
        }
    }

    useEffect(() => {
        setTenantRoles(tenantRolesList);
    }, [tenantRolesList]);

    useEffect(() => {
        startLoadingAppRoles();
        startLoadingControllers();
        setTenantRoles([]);
    }, [startLoadingAppRoles,startLoadingControllers]);
    
    
    useEffect(() => {
        setRoleControllerPermissionList(controllerRolePermissionsList)
    },[controllerRolePermissionsList]);


    const handleAccessSelect = (event,controller_id) => {
        console.log('event',event.target.value)
        const updatedData = roleControllerPermissionList.map(role => {
            if(role.controller_id === controller_id){
              return {...role,role_id:event.target.value}
            }
            return role;
        });
        setRoleControllerPermissionList(updatedData);
    }


    const handleSwitchChange = (controller_id) => (event) => {
        const updatedData = roleControllerPermissionList.map(role => {
            if(role.controller_id === controller_id){
              return {...role,status:event.target.checked ? 1 : 0}
            }
            return role;
        });
        setRoleControllerPermissionList(updatedData);
    };

    const handleSaveData = () => {
        let idList = {
            'tenantId'      : tenantValue,
            'tenantRoleId'  : tenantRoleValue,
        };
        let controllerRolePermission  = roleControllerPermissionList;
        dispatch(updateControllerRolePermissions(idList,controllerRolePermission));
    }

    
    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/roles">Roles</Link>
                                <Link className="tabingLinks" to="/web/users">Users</Link>
                                {/* <Link className="tabingLinks" to="/web/app/users">Manage SiteTech app users</Link> */}
                                <Link className="tabingLinks" to="/web/permissions">Access Control</Link>
                                <Tab label="Controller Access Control" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <ControllerMappingFilter
                                tenantValue={tenantValue}
                                tenantRoles={tenantRoles}
                                tenantRoleValue={tenantRoleValue}
                                changeTenantHandler={changeTenantHandler}
                                changeTenantRoleHandler={changeTenantRoleHandler}
                            />
                            <ControllersRoleMapping 
                                showController={showController} 
                                controllerList={controllerList}
                                appRolesList={appRolesList}
                                handleSwitchChange={handleSwitchChange}
                                handleSaveData={handleSaveData}
                                handleAccessSelect={handleAccessSelect}
                                controllerRolePermissionsList={roleControllerPermissionList}
                            /> 
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>
        </Box>
    )
}

const mapStateToProps = (state) => ({
    isLoading                       :   getAppRolesLoading(state),  
    appRolesList                    :   getAppRolesList(state), 
    controllerList                  :   getControllersList(state), 
    controllerTenantPermission      :   getControllersTenantPermission(state), 
    tenantRolesList                 :   getTenantRoles(state),
    controllerRolePermissionsList   :   getControllerRolePermissionsList(state), 
});

const mapDispatchToProps = (dispatch) => ({
    startLoadingAppRoles: ()                         => dispatch(loadAppRolesList( )),
    startLoadingControllers: ()                      => dispatch(loadControllersList()),
    startLoadingControllersTenantPermission: (tenantId,tenantRoleId)             => dispatch(loadControllerTenantPermission(tenantId,tenantRoleId)),
    startLoadingControllerRolePermissions: (tenantId,tenantRoleId)  => dispatch(loadControllerRolePermissionsList(tenantId,tenantRoleId)),
});
  
export default connect(mapStateToProps, mapDispatchToProps)(ManageControllerRoleMapping);